import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';
import { withModal } from 'components/modal/ModalHOC';

import SOVQueriesModal from 'modules/insights/sov/components/queries/modals/SOVQueriesModal';
import SOVCallout from '../SOVCalloutV2';

import { __t, applyTranslations } from 'utils/language';
import { WITH_GALLERY_MODAL_CONFIG } from 'utils/gallery';
import { CREATE, FIXED_TO_TOP, QUERY } from 'modules/insights/sov/utils/sov';
import { CONSUMER_INSIGHTS, VIDEO_TUTORIAL_GALLERY_MODAL_OBJECT } from 'modules/insights/sov/utils/consumer-insights/sov-consumer-insights';

import './sov-callout-consumer-insights.scss';

import type {
  SOVQuerySave,
  SOVReport,
  SOVReportType
} from 'modules/insights/sov/types';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./sov-callout-consumer-insights.i18n.json'));

type Props = {
  report: SOVReport,
  reportType: SOVReportType | undefined | null,
  onSaveQuery: (a: SOVQuerySave) => void
};

const MSG_KEY = 'sov_callout_consumer_insights';

const ActionButtonWithQueriesModal = withModal(ActionButton, {
  modalContent: SOVQueriesModal,
  width: 'small',
  positionOverride: FIXED_TO_TOP
});

const DivWithGalleryModal = withModal(<div />, WITH_GALLERY_MODAL_CONFIG);

class SOVCalloutConsumerInsights extends React.PureComponent<Props> {
  private getItems(): Array<{ title: string, body: string }> {
    const { reportType } = this.props;

    return ['step_one', 'step_two', 'step_three'].map(step => ({
      title: __t(`${MSG_KEY}.${reportType}.${step}_title`),
      body: __t(`${MSG_KEY}.${reportType}.${step}_body`)
    }));
  }

  private renderLink(): React.ReactNode {
    return (
      <DivWithGalleryModal
        modalContentProps={{
          theme: 'white',
          items: [VIDEO_TUTORIAL_GALLERY_MODAL_OBJECT],
          currentPosition: 0
        }}
        className="sov-callout-consumer-insights__link"
      >
        {__t(`${MSG_KEY}.video_tutorial`)}
      </DivWithGalleryModal>
    );
  }

  private renderButton(): React.ReactNode {
    const { report, onSaveQuery } = this.props;

    return (
      <ActionButtonWithQueriesModal
        color="primary"
        className="sov-callout-consumer-insights__button"
        modalContentProps={{
          report,
          query: {},
          pageType: CONSUMER_INSIGHTS,
          sectionType: QUERY,
          actionType: CREATE,
          onSaveQuery
        }}
      >
        {__t(`${MSG_KEY}.button`)}
      </ActionButtonWithQueriesModal>
    );
  }

  private renderTeaser(): React.ReactNode {
    const { reportType } = this.props;

    if (reportType === 'instagram' || reportType === 'youtube') {
      return (
        <img
          src={`/static/images/${reportType}-development-chart.png`}
          className="sov-callout-collabary__teaser"
          alt=""
        />
      );
    }

    return null;
  }

  render(): React.ReactNode {
    const { reportType } = this.props;

    return (
      <SOVCallout
        headerText={__t(`${MSG_KEY}.${reportType}.header`)}
        items={this.getItems()}
        content={this.renderLink()}
        teaser={this.renderTeaser()}
        button={this.renderButton()}
        className="sov-callout-consumer-insights"
      />
    );
  }
}

export default SOVCalloutConsumerInsights;
